import { render, staticRenderFns } from "./recollectQueries.vue?vue&type=template&id=8350c050"
import script from "./recollectQueries.vue?vue&type=script&lang=js"
export * from "./recollectQueries.vue?vue&type=script&lang=js"
import style0 from "./recollectQueries.vue?vue&type=style&index=0&id=8350c050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports